// 按钮渲染
import router from '@/router'
import store from '@/store'
export default {
  inserted(el, binding) {
    try {
      var rank = store.getters.userInfo?.rank??0
      var { value } = binding
      var meta = router.history.current.meta
      var permits = meta.permits ?? []
      if ((permits.indexOf(value) < 0 && ((rank & 1) != 1 && (rank & 2) != 2)) ) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } catch (error) {
      el.parentNode && el.parentNode.removeChild(el)
      console.log(error)
    }
  }
}
